<aza-rws-profile-header [titleTranslationKey]="'CONTACTS'" (closed)="onClosed()">
  <div class="profile-contact-invite">
    <button (click)="onInviteContact()">
      <span translate>INVITE</span>
    </button>
  </div>
</aza-rws-profile-header>
<aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject"
[pageSize]="5"></aza-rws-pager>

<section class="aza-section aza-theme">
  <div class="aza-section-content aza-section-colors aza-contact-list-filter-container">
    <div class="aza-form-field-area">
      <div class="aza-input-field aza-search-contact">
        <div class="aza-field-content aza-field-type-text">
          <label class="aza-text">
            <input [(ngModel)]="contactSearchText" (input)="onFilterChanged()"
              placeholder="{{'SEARCH_CONTACT' | translate}}" />
            </label>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="profile-contacts-list-container">
    @for (contact of contacts; track contact.email + '_' + contact.id) {
      <section (click)="onContactClick(contact)" class="aza-section aza-theme">
        <div class="aza-section-content profile-contact">
          <div class="profile-contact-first-name">
            <span translate>FIRST_NAME</span>:
            <span>{{contact.first_name}}</span>
          </div>
          <div class="profile-contact-last-name">
            <span translate>LAST_NAME</span>:
            <span>{{contact.last_name}}</span>
          </div>
          <div class="profile-contact-email">
            <span translate>EMAIL</span>:
            <span>{{contact.email}}</span>
          </div>
        </div>
        <section class="section-divider aza-section aza-theme">
          <div class="aza-section-content"></div>
        </section>
      </section>
    }
  </div>

  <aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject"
  [pageSize]="5"></aza-rws-pager>
